/* @flow */
import produce from 'immer'

export default function reducer(state, action: any) {
  const initialState = action.__initialData.defaultProps
  return produce(state, draft => {
    switch (action.type) {
      case 'CHANGE_TITLE':
        draft.title = action.value
        break
      case 'CHANGE_SUB_TITLE':
        draft.subTitle = action.value
        break
      case 'CHANGE_PARAGRAPH':
        draft.paragraph = action.value
        break
      case 'CHANGE_IMAGE':
        {
          const { blockIdx, idx, url, dimensions } = action.value
          draft.images[blockIdx][idx].imgUrl = url
          draft.images[blockIdx][idx].imgDimensions = dimensions
          draft.images[blockIdx][idx].imgCropParams = {}
        }
        break
      case 'ADD_BLOCK':
        const afterIdx = action.value
        draft.images.splice(afterIdx + 1, 0, initialState.images[0])
        break
      case 'REMOVE_BLOCK':
        const imgIdx_ = action.value
        draft.images.splice(imgIdx_, 1)
        break
      case 'SET_IMG_CROP_PARAMS': {
        const { imgCropParams, idx, blockIdx } = action.value
        draft.images[blockIdx][idx].imgCropParams = imgCropParams
      }
      case 'CHANGE_TITLE_ALIGNMENT': {
        draft.titleAlignment = action.value
        break
      }
      case 'CHANGE_SUBTITLE_ALIGNMENT': {
        draft.subTitleAlignment = action.value
        break
      }
      case 'CHANGE_PARAGRAPH_ALIGNMENT': {
        draft.paragraphAlignment = action.value
        break
      }
    }
  })
}
